import Plugin from 'src/plugin-system/plugin.class';
import anime from 'animejs/lib/anime.es.js';

export default class TransitionLoaderPlugin extends Plugin {

    init() {

        anime.timeline({ loop: false })
            .add({
                targets: '.transition-loader',
                translateY: '100%',
                easing: "easeInOutQuad",
                duration: 1500,
                begin: function() {
                    var video = $('.hero-widget__video-wrapper video:visible');
                    if (video.length) {
                        video.get(0).pause();
                        video.get(0).currentTime = 0;
                    }
                },
                complete: function() {
                    document.querySelector('.transition-loader').style.visibility = 'hidden';

                    var video = $('.hero-widget__video-wrapper video:visible');
                    if (video.length) {
                        video.get(0).play();
                    }
                }
            });

        $('.sub-navbar-products .nav-link').on('click', function(e) {
            e.preventDefault();

            var href = $(this).attr('href');

            var subNavs = document.querySelectorAll(".sub-navbar");
            subNavs.forEach((item, thisI) => {
                item.classList.remove("is--open");
            });

            document.querySelector('.header').classList.toggle("is--open");

            document.querySelector('.transition-loader').style.visibility = 'visible';
            anime.timeline({ loop: false })
                .add({
                    targets: '.transition-loader',
                    translateY: ['-100%', '0'],
                    easing: "easeInOutQuad",
                    duration: 1500,
                    complete: function() {
                        window.location = href;
                    }
                });
        });

    }

}